import { effects } from './store/effects/index';
import { EffectsModule } from '@ngrx/effects';
import { AuthCoreModule, TokenInterceptorService } from '@anecdotes/auth-core';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PlatformRootModule } from 'core';
import { AppRoutingModule } from './app-routing.module';
import { NavbarHostComponent, NoAccessComponent, NoRequiredPermissionsComponent, NoRoleComponent, RootComponent, UpdatePromptComponent } from './components';
import {
  AuditorSimulationGuard,
  DefaultRedirectionGuard,
  DeprecatedRoutesHandlerService,
  FeatureFlagGuard,
  SignOutInterceptor,
  SupportConfigService,
} from './services';
import { DataManipulationModule } from '@anecdotes/design-system/data-manipulation';
import { SurveyService, UserFlowInitializer } from './services/external-services';
import { ControlsSharedModule } from '@anecdotes/shared-controls';
import { MaintenanceInterceptor } from '../../services';
import { TranslateModule } from '@ngx-translate/core';
import { FeaturesManagementModule } from '@anecdotes/feature-management';
import { SupportModule } from '@anecdotes/support';
import { overrideModules, overrideProviders } from './build-config-overrides/build-config-override.prod';
import { UserManagementCoreModule } from '@anecdotes/user-management-core';
import { FeatureFlagsModule } from '@anecdotes/feature-flags';

@NgModule({
  declarations: [
    RootComponent,
    UpdatePromptComponent,
    NoRequiredPermissionsComponent,
    NavbarHostComponent,
    NoRoleComponent,
    NoAccessComponent
  ],
  imports: [
    AppRoutingModule,
    PlatformRootModule,
    DataManipulationModule.forRoot(),
    LoadersModule.forRoot(),
    ControlsSharedModule.forRoot(),
    EffectsModule.forFeature(effects),
    FeaturesManagementModule.forRoot(),
    SupportModule.forRoot(SupportConfigService),
    UserManagementCoreModule.forRoot(),
    TranslateModule,
    FeatureFlagsModule,
    ...overrideModules,
    AuthCoreModule,
  ],
  providers: [
    UserFlowInitializer,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SignOutInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MaintenanceInterceptor,
      multi: true,
    },
    DefaultRedirectionGuard,
    DeprecatedRoutesHandlerService,
    SurveyService,
    ...overrideProviders,
    FeatureFlagGuard,
    AuditorSimulationGuard,
  ],
})
export class PlatformModule {
  constructor(deprecatedRoutesHandlerService: DeprecatedRoutesHandlerService) {
    deprecatedRoutesHandlerService.handleNavigation();
  }
}
